<template>
  <div class="consent-page">
    <!-- 顶部导航栏 -->
    <div class="header-bar">
      <van-icon name="arrow-left" class="back-icon" @click="goBack" />
      <h1 class="page-title">知情同意书</h1>
    </div>

    <div class="content-wrapper">
      <div class="book-image">
        <img :src="bookImage1" alt="知情同意书第一页" />
      </div>
      <div class="book-image book-image--second">
        <img :src="bookImage2" alt="知情同意书第二页" />
        <div class="signature-slot">
          <van-loading
            v-if="loadingDetail"
            type="spinner"
            size="20px"
            color="#c49b45"
          />
          <img
            v-else-if="signatureImage"
            :src="signatureImage"
            alt="签名"
            class="signature-image"
          />
          <div v-else class="signature-placeholder-text">暂无签名</div>
        </div>
        <div class="phone-number" v-if="privilegeInfo">
          {{ privilegeInfo.personPhone }}
        </div>
        <div class="date-time" v-if="signTimeArr.length > 0">
          <div class="date-time-item1">{{ signTimeArr[0] }}</div>
          <div class="date-time-item2">{{ signTimeArr[1] }}</div>
          <div class="date-time-item3">{{ signTimeArr[2] }}</div>
        </div>
      </div>
    </div>

    <div
      v-if="!loadingDetail && showSignButton"
      class="fixed-controls"
      :class="[{ 'space-between': signatureImage && showSignButton }]"
    >
      <div
        v-if="signatureImage"
        class="signature-box"
        :style="signatureBoxStyle"
      >
        <img :src="signatureImage" alt="签名" />
        <van-icon
          v-if="showSignButton"
          name="cross"
          class="floating-remove"
          @click="removeSignature"
        />
      </div>
      <div
        class="sign-button"
        @click="handleMainAction"
        :class="{ confirmed: !!signatureImage }"
      >
        <span>{{ signatureImage ? "确认签名" : "签字" }}</span>
      </div>
    </div>

    <!-- 签名画布弹窗 -->
    <van-popup
      v-model="showSignature"
      position="bottom"
      :style="{ height: '100%', width: '100%' }"
      round
      closeable
      class="signature-popup"
    >
      <div class="signature-container">
        <div class="signature-header">
          <h3>请在此处签名</h3>
        </div>
        <div class="signature-canvas-wrapper">
          <div v-if="!hasDrawn" class="signature-guide">请在此处手写签名</div>
          <canvas
            ref="signatureCanvas"
            class="signature-canvas"
            @touchstart="handleTouchStart"
            @touchmove="handleTouchMove"
            @touchend="handleTouchEnd"
            @mousedown="handleMouseDown"
            @mousemove="handleMouseMove"
            @mouseup="handleMouseUp"
            @mouseleave="handleMouseUp"
          ></canvas>
        </div>
        <div class="signature-actions">
          <van-button class="clear-btn" @click="clearSignature"
            >清除</van-button
          >
          <van-button
            type="primary"
            class="confirm-btn"
            @click="confirmSignature"
            >确定</van-button
          >
        </div>
      </div>
    </van-popup>
    <van-overlay :show="loadingUpload" :z-index="3000" class="upload-overlay">
      <van-loading type="spinner" color="#fff" size="42px" vertical>
        上传中...
      </van-loading>
    </van-overlay>
  </div>
</template>

<script>
import bookImage1 from "@/assets/client/book_01.png";
import bookImage2 from "@/assets/client/book_02.png";
import {
  onUploadImage,
  onConfirmSign,
  onSelectXinWeiLaiPersonPrivilege,
} from "@/api/client";
export default {
  name: "ConsentForm",
  data() {
    return {
      signTimeArr: [],
      showSignature: false,
      canvas: null,
      ctx: null,
      isDrawing: false,
      lastX: 0,
      lastY: 0,
      signatureImage: null,
      signatureUrl: "",
      signatureSource: "",
      hasDrawn: false,
      canvasSize: {
        width: 0,
        height: 0,
      },
      signatureBoxStyle: {
        width: "150px",
        height: "150px",
      },
      signatureBoxStyle2: {
        width: "200px",
        height: "100px",
      },
      loadingUpload: false,
      personPrivilgeId: this.$route.query.personPrivilgeId || "",
      loadingDetail: false,
      privilegeInfo: null,
      bookImage1,
      bookImage2,
    };
  },
  created() {
    this.loadPrivilegeDetail();
  },
  mounted() {
    this.initCanvas();
  },
  methods: {
    handleMainAction() {
      if (this.signatureUrl) {
        this.$toast("签名已确认");
        return;
      }
      this.showSignaturePad();
    },
    async uploadSignature(dataUrl) {
      if (!dataUrl) return null;
      try {
        const file = this.dataURLtoFile(dataUrl, "signature.png");
        const formData = new FormData();
        formData.append("file", file);
        const res = await onUploadImage(formData);
        if (res.code === 200 && res.data) {
          const url = res.data.imgUrl || dataUrl;
          return url;
        } else {
          this.$toast(res.msg || "图片上传失败");
          return null;
        }
      } catch (error) {
        console.error("签名上传失败", error);
        this.$toast("图片上传失败");
        return null;
      }
    },

    dataURLtoFile(dataurl, filename) {
      const arr = dataurl.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    goBack() {
      this.$router.go(-1);
    },
    initCanvas() {
      this.$nextTick(() => {
        if (this.$refs.signatureCanvas) {
          this.canvas = this.$refs.signatureCanvas;
          this.ctx = this.canvas.getContext("2d");
          this.resizeCanvas();
        }
      });
    },
    resizeCanvas() {
      if (!this.canvas) return;
      const rect = this.canvas.getBoundingClientRect();
      this.canvas.width = rect.width * window.devicePixelRatio;
      this.canvas.height = rect.height * window.devicePixelRatio;
      this.canvas.style.width = rect.width + "px";
      this.canvas.style.height = rect.height + "px";
      this.ctx.setTransform(1, 0, 0, 1, 0, 0);
      this.ctx.scale(window.devicePixelRatio, window.devicePixelRatio);

      // 填充白色背景，方便生成的图片背景为白色
      this.ctx.fillStyle = "#ffffff";
      this.ctx.fillRect(0, 0, rect.width, rect.height);

      this.canvasSize = {
        width: rect.width,
        height: rect.height,
      };
      this.updateSignatureBoxStyle();

      // 设置画笔样式
      this.ctx.strokeStyle = "#000";
      this.ctx.lineWidth = 2;
      this.ctx.lineCap = "round";
      this.ctx.lineJoin = "round";
    },
    showSignaturePad() {
      this.showSignature = true;
      this.hasDrawn = false;
      this.$nextTick(() => {
        this.initCanvas();
      });
    },
    getEventPos(e) {
      const rect = this.canvas.getBoundingClientRect();
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const clientY = e.touches ? e.touches[0].clientY : e.clientY;
      return {
        x: clientX - rect.left,
        y: clientY - rect.top,
      };
    },
    handleTouchStart(e) {
      e.preventDefault();
      const pos = this.getEventPos(e);
      this.startDrawing(pos.x, pos.y);
    },
    handleTouchMove(e) {
      e.preventDefault();
      if (this.isDrawing) {
        const pos = this.getEventPos(e);
        this.draw(pos.x, pos.y);
      }
    },
    handleTouchEnd(e) {
      e.preventDefault();
      this.stopDrawing();
    },
    handleMouseDown(e) {
      const pos = this.getEventPos(e);
      this.startDrawing(pos.x, pos.y);
    },
    handleMouseMove(e) {
      if (this.isDrawing) {
        const pos = this.getEventPos(e);
        this.draw(pos.x, pos.y);
      }
    },
    handleMouseUp(e) {
      this.stopDrawing();
    },
    startDrawing(x, y) {
      this.isDrawing = true;
      this.lastX = x;
      this.lastY = y;
      this.hasDrawn = true;
      this.ctx.beginPath();
      this.ctx.moveTo(x, y);
    },
    draw(x, y) {
      if (!this.isDrawing) return;
      this.ctx.lineTo(x, y);
      this.ctx.stroke();
      this.lastX = x;
      this.lastY = y;
    },
    stopDrawing() {
      this.isDrawing = false;
    },
    clearSignature() {
      if (this.ctx && this.canvas) {
        const rect = this.canvas.getBoundingClientRect();
        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.ctx.fillStyle = "#ffffff";
        this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
        if (rect.width > 0 && rect.height > 0) {
          this.resizeCanvas();
        }
      }
      this.signatureImage = null;
      this.signatureUrl = "";
      this.signatureSource = "";
      this.hasDrawn = false;
      this.signatureBoxStyle = {
        width: "150px",
        height: "150px",
      };
      if (this.privilegeInfo) {
        this.$set(this.privilegeInfo, "signUrl", "");
      }
      if (!this.showSignature) {
        this.canvas = null;
        this.ctx = null;
      } else {
        this.$nextTick(() => {
          this.resizeCanvas();
        });
      }
    },
    async confirmSignature() {
      if (!this.canvas) {
        this.$toast("请先签名");
        return;
      }

      // 检查画布是否有内容（检查是否只有白色背景）
      const imageData = this.ctx.getImageData(
        0,
        0,
        this.canvas.width,
        this.canvas.height
      );
      let hasContent = false;
      for (let i = 0; i < imageData.data.length; i += 4) {
        // 检查 RGB 通道，如果不是白色（255,255,255），说明有内容
        const r = imageData.data[i];
        const g = imageData.data[i + 1];
        const b = imageData.data[i + 2];
        if (r !== 255 || g !== 255 || b !== 255) {
          hasContent = true;
          break;
        }
      }

      if (!hasContent) {
        this.$toast("请先签名");
        return;
      }

      // 生成竖屏图片
      const rotatedCanvas = document.createElement("canvas");
      rotatedCanvas.width = this.canvas.height;
      rotatedCanvas.height = this.canvas.width;
      const rctx = rotatedCanvas.getContext("2d");
      rctx.fillStyle = "#ffffff";
      rctx.fillRect(0, 0, rotatedCanvas.width, rotatedCanvas.height);
      rctx.translate(rotatedCanvas.width / 2, rotatedCanvas.height / 2);
      rctx.rotate(-Math.PI / 2);
      rctx.drawImage(
        this.canvas,
        -this.canvas.width / 2,
        -this.canvas.height / 2,
        this.canvas.width,
        this.canvas.height
      );

      const signatureDataUrl = rotatedCanvas.toDataURL("image/png");
      this.signatureSource = signatureDataUrl;
      this.signatureImage = signatureDataUrl;
      this.canvasSize = {
        width: rotatedCanvas.width,
        height: rotatedCanvas.height,
      };
      this.updateSignatureBoxStyle();

      if (!this.personPrivilgeId) {
        this.$toast("缺少权益信息，无法确认签名");
        return;
      }

      this.loadingUpload = true;
      try {
        const uploadedUrl = await this.uploadSignature(this.signatureSource);
        if (!uploadedUrl) {
          return;
        }
        const res = await onConfirmSign({
          signUrl: uploadedUrl,
          personPrivilgeId: this.personPrivilgeId,
        });
        if (res.code === 200) {
          this.$toast("签名确认成功");
          this.showSignature = false;
          this.signatureUrl = uploadedUrl;
          this.signatureImage = uploadedUrl;
          this.signatureSource = "";
          if (this.privilegeInfo) {
            this.$set(this.privilegeInfo, "signUrl", uploadedUrl);
          }
        } else {
          this.$toast(res.msg || "签名确认失败");
        }
      } catch (error) {
        console.error("确认签名失败", error);
        this.$toast("签名确认失败");
      } finally {
        this.loadingUpload = false;
      }

      // 这里可以将签名图片上传到服务器或保存
    },
    removeSignature() {
      this.clearSignature();
    },
    updateSignatureBoxStyle() {
      const { width, height } = this.canvasSize;
      if (!width || !height) {
        this.signatureBoxStyle = {
          width: "150px",
          height: "150px",
        };
        return;
      }
      const targetHeight = 150;
      const scale = targetHeight / height;
      let targetWidth = width * scale;
      targetWidth = Math.max(80, Math.min(targetWidth, 200));
      this.signatureBoxStyle = {
        width: `${targetWidth}px`,
        height: `${targetHeight}px`,
      };
    },
    async loadPrivilegeDetail() {
      if (!this.personPrivilgeId) {
        this.$toast("缺少权益信息");
        return;
      }
      this.loadingDetail = true;
      try {
        const res = await onSelectXinWeiLaiPersonPrivilege({
          personPrivilgeId: this.personPrivilgeId,
        });
        if (res.code === 200 && res.data) {
          this.privilegeInfo = res.data;
          if (res.data.signTime) {
            this.signTimeArr = res.data.signTime.split("-");
          }
          if (res.data.signUrl) {
            this.signatureUrl = res.data.signUrl;
            this.signatureImage = res.data.signUrl;
            this.signatureSource = "";
            this.signatureBoxStyle = {
              width: "150px",
              height: "150px",
            };
          } else {
            this.signatureUrl = "";
            this.signatureImage = null;
            this.signatureSource = "";
            this.signatureBoxStyle = {
              width: "150px",
              height: "150px",
            };
          }
        } else {
          this.$toast(res.msg || "加载签名信息失败");
        }
      } catch (error) {
        console.error("加载签名信息失败", error);
        this.$toast("加载签名信息失败");
      } finally {
        this.loadingDetail = false;
      }
    },
  },
  watch: {
    showSignature(newVal) {
      if (newVal) {
        this.hasDrawn = false;
        this.$nextTick(() => {
          setTimeout(() => {
            this.resizeCanvas();
          }, 100);
        });
      } else {
        // 关闭时不清除，以便下次打开时保留
      }
    },
  },
  computed: {
    showSignButton() {
      return !this.signatureUrl;
    },
  },
};
</script>

<style scoped lang="less">
.consent-page {
  min-height: 100vh;
  background: #fff;
  display: flex;
  flex-direction: column;
}

/* 顶部导航栏 */
.header-bar {
  position: sticky;
  top: 0;
  z-index: 100;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.back-icon {
  position: absolute;
  left: 16px;
  font-size: 20px;
  color: #333;
  cursor: pointer;
}

.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

/* 空状态内容 */
.content-wrapper {
  flex: 1;
  // padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.book-image {
  position: relative;
}

.book-image img {
  width: 100%;
  display: block;
  border-radius: 12px;
}

.book-image--second {
  position: relative;
}

.signature-slot {
  position: absolute;
  width: 50px;
  height: 25px;
  left: 90px;
  top: 235px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.96);
  overflow: hidden;
  box-sizing: border-box;
}
.phone-number {
  position: absolute;
  width: 100px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: #333;
  left: 90px;
  top: 270px;
}
.date-time {
  position: absolute;
  width: 100px;
  left: 80px;
  top: 310px;
  font-size: 12px;
  color: #333;
  display: flex;
  align-items: center;
  overflow: hidden;
  box-sizing: border-box;
}
.date-time div {
  margin-right: 10px;
}

.signature-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.signature-placeholder-text {
  font-size: 12px;
  color: #999;
  text-align: center;
}

/* 签字按钮 */
.sign-button {
  z-index: 99;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 12px 20px;
  background: linear-gradient(
    135deg,
    rgba(246, 201, 144, 1) 0%,
    rgba(253, 218, 181, 1) 100%
  );
  color: #8b4513;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(212, 175, 55, 0.25);
  transition: all 0.3s;
  padding-right: 22px;
  padding-left: 20px;
}

.sign-button:active {
  transform: scale(0.97);
  box-shadow: 0 2px 6px rgba(212, 175, 55, 0.2);
}

/* 签名弹窗 */
.signature-popup {
  z-index: 2000;
}

.signature-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fff;
}

.signature-header {
  padding: 20px;
  text-align: center;
  border-bottom: 1px solid #eee;
  flex-shrink: 0;
}

.signature-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.signature-canvas-wrapper {
  flex: 1;
  padding: 20px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  position: relative;
}

.signature-canvas {
  width: 100%;
  height: 100%;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  touch-action: none;
  cursor: crosshair;
}

.signature-guide {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(90deg);
  color: rgba(0, 0, 0, 0.25);
  font-size: 18px;
  letter-spacing: 2px;
  pointer-events: none;
}

.signature-actions {
  padding: 20px;
  display: flex;
  gap: 15px;
  flex-shrink: 0;
  border-top: 1px solid #eee;
}

.clear-btn {
  flex: 1;
  height: 44px;
  border: 1px solid #ddd;
  background: #fff;
  color: #333;
}

.confirm-btn {
  flex: 1;
  height: 44px;
  background: linear-gradient(
    135deg,
    rgba(246, 201, 144, 1) 0%,
    rgba(253, 218, 181, 1) 100%
  );
  border: none;
  color: #8b4513;
  font-weight: 600;
}

/* 签名显示区域 */

.signature-display {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.96);
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  position: relative;
  box-sizing: border-box;
}

.signature-display img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.signature-url {
  margin-top: 12px;
  font-size: 12px;
  color: #666;
  word-break: break-all;
  text-align: center;
}

.fixed-controls {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  z-index: 2000;
  background: linear-gradient(
    to top,
    rgba(255, 255, 255, 0.95),
    rgba(255, 255, 255, 0)
  );
  &.space-between {
    justify-content: space-between;
  }
}
.fixed-controls .signature-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.96);
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  position: relative;
  // overflow: hidden;
  box-sizing: border-box;
}
.fixed-controls .signature-box img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
}

.fixed-controls .signature-box .floating-remove {
  position: absolute;
  top: -8px;
  right: -8px;
  font-size: 14px;
  color: #bbb;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  padding: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.upload-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.6);
}
</style>
